/** 首页引导 */
export const stepsFirstHome = [
	{
		element: '#guide-model',
		popover: {
			title: '请先选择模式',
			description: '点击选择模式',
			position: 'bottom'
		}
	},
	{
		element: '#guide-scenece',
		popover: {
			title: '请选择场景',
			description: '点击选择场景',
			position: 'bottom'
		},
		padding: 5
	}
];

/** 二级切换场景引导 */
export const setpsHeader = [
	{
		element: '#guide-header',
		popover: {
			title: '切换模式场景',
			description: '点击可以切换模式场景',
			position: 'bottom'
		}
	}
];

/** 首页引导弹框内容 */
export const driverObj: any = {
	animate: true,
	opacity: 0.75,
	padding: 10,
	allowClose: true,
	overlayClickNext: true,
	doneBtnText: '完成',
	closeBtnText: '关闭',
	nextBtnText: '下一步',
	prevBtnText: '上一步'
};

/** 二级切换场景引导弹框内容 */
export const driverHeader: any = {
	closeBtnText: '我知道了',
	opacity: 0.7,
	allowClose: true
};
